class ScrollBar extends HTMLElement {
  constructor() {
    super();
    this.lenis = null;
    this.hideScrollbarTimeout = null;
    this.initLenis();
    this.initScrollbar();
  }

  connectedCallback() {
    this.lenis.on("scroll", () => this.showScrollbarTemporarily());
    this.setupResizeHandler();
    this.setupAnchorLinks();
  }

  initLenis() {
    this.lenis = new Lenis({
      easing: (e) => Math.min(1, 1.001 - Math.pow(2, -5 * e)),
      direction: "vertical",
      gestureDirection: "vertical",
      smooth: true,
      mouseMultiplier: 1,
      smoothTouch: false,
      touchMultiplier: 2,
      infinite: false,
    });
    const raf = (time) => {
      this.lenis.raf(time);
      requestAnimationFrame(raf);
    };
    requestAnimationFrame(raf);
  }

  showScrollbarTemporarily() {
    document.documentElement.classList.add("show-scrollbar");
    clearTimeout(this.hideScrollbarTimeout);
    this.hideScrollbarTimeout = setTimeout(() => {
      document.documentElement.classList.remove("show-scrollbar");
    }, 100);
  }

  initScrollbar() {
    let startY = null;
    const inner = this.querySelector(".inner");
    const thumb = this.querySelector(".thumb");
    let innerHeight = inner.offsetHeight;
    let thumbHeight = thumb.offsetHeight;

    const calculateThumbPosition = (scroll, limit) => {
      const maxThumbPosition = innerHeight - thumbHeight;
      thumb.style.transform = `translate3d(0, ${(scroll / limit) * maxThumbPosition}px, 0)`;
    };

    const updateSizes = () => {
      innerHeight = inner.offsetHeight;
      thumbHeight = thumb.offsetHeight;
    };

    window.addEventListener("resize", updateSizes);

    const onPointerMove = (event) => {
      if (startY === null) return;
      event.preventDefault();
      const deltaY = event.clientY - startY;
      const maxThumbPosition = innerHeight - thumbHeight;
      const scrollPosition = ((Math.max(0, Math.min(deltaY, maxThumbPosition)) / maxThumbPosition) * this.lenis.limit);
      this.lenis.scrollTo(scrollPosition, { immediate: true });
    };

    const onPointerDown = (event) => {
      startY = event.clientY - thumb.getBoundingClientRect().top;
      thumb.classList.add("grabbing");
    };

    const onPointerUp = () => {
      startY = null;
      thumb.classList.remove("grabbing");
    };

    thumb.addEventListener("pointerdown", onPointerDown);
    window.addEventListener("pointermove", onPointerMove);
    window.addEventListener("pointerup", onPointerUp);

    this.lenis.on("scroll", ({ scroll, limit }) => {
      calculateThumbPosition(scroll, limit);
    });
  }

  setupResizeHandler() {
    let resizeTimeout;
    window.addEventListener("resize", () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        if (typeof this.lenis.update === "function") {
          this.lenis.update();
        }
      }, 150);
    });
  }

  setupAnchorLinks() {
    const anchorLinks = document.querySelectorAll('a[href^="#"]');
    anchorLinks.forEach((link) => {
      link.addEventListener("click", (event) => {
        event.preventDefault();
        const targetId = link.getAttribute("href").substring(1);
        const targetElement = document.getElementById(targetId);
        if (targetElement) {
          this.lenis.scrollTo(targetElement);
        }
      });
    });
  }
}

customElements.define("lenis-bar", ScrollBar);